import { IPromoCardProps } from "@/domains/auth/types";
import styles from "./index.module.scss";
import Image from "next/image";
import { useCallback } from "react";
import { useTranslations } from "next-intl";
import getSymbolFromCurrency from "currency-symbol-map";
import { countryToCurrency } from "@/utils/country-to-currency";

export default function PromoCard({
  promo,
  promoId,
  onActivePromo,
  country,
  onMoreDetail,
}: IPromoCardProps) {
  const tPromo = useTranslations("AuthRegistrationPromo");

  const handleActivePromo = useCallback(
    (value: string) => {
      onActivePromo(value !== promoId ? value : null);
    },
    [promoId, onActivePromo],
  );

  const currency = countryToCurrency(country.toUpperCase());

  return (
    <>
      <div className={styles.bonus}>
        <div className={styles.bonus__title}>
          {promo.title} <span className={styles.accent}>{promo.rate}</span>
        </div>
        <div className={styles.bonus__content}>
          <div className={styles.bonus__img_wrapper}>
            <Image
              className={`${styles.bonus__img} ${promoId === promo.id && styles.active}`}
              src={"/images/bonus.png"}
              width={132}
              height={132}
              alt="bonus"
            />
            {promoId === promo.id && (
              <span className={styles.bonus__status}>{tPromo("enable")}</span>
            )}
          </div>

          <div className={styles.bonus__properties}>
            <div className={styles.bonus__roperties_item}>
              <div className={styles.bonus__properties_title}>{tPromo("maxAmount")}</div>
              <div className={styles.bonus__properties_value}>
                {promo.maxBonus}&nbsp;
                <span className={styles.bonus__properties_currecy}>
                  {getSymbolFromCurrency(currency || "EUR")}
                </span>
              </div>
            </div>

            <div className={styles.bonus__roperties}>
              <div className={styles.bonus__roperties_item}>
                <div className={styles.bonus__properties_title}>{tPromo("minAmount")}</div>
                <div className={styles.bonus__properties_value}>
                  {promo.minDeposit}&nbsp;
                  <span className={styles.bonus__properties_currecy}>
                    {getSymbolFromCurrency(currency || "EUR")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.bonus__buttons}>
          <button
            className={`${styles.bonus__btn} ${styles.bonus__btn_info}`}
            onClick={() => onMoreDetail(promo)}
          >
            {tPromo("more")}
          </button>
          <button
            className={`${styles.bonus__btn} ${styles.bonus__btn_accent} ${promoId === promo.id && styles.active}`}
            onClick={() => handleActivePromo(promo.id)}
          >
            {promoId === promo.id ? tPromo("cancel") : tPromo("apply")}
          </button>
        </div>
      </div>
    </>
  );
}
